import Modal from 'components/Luxkit/Modal/Modal'
import Clickable from 'components/Common/Clickable/Clickable'
import BodyText from 'components/Luxkit/Typography/BodyText'
import useToggle from 'hooks/useToggle'
import React from 'react'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import styled from 'styled-components'
import HelpPane from 'components/Common/HelpPane'

const MiddledTooltipIcon = styled(LineInfoCircleIcon)`
  vertical-align: middle;
`

function OfferPropertyNonRefundablePolicy() {
  const [isPolicyOpen, togglePolicy] = useToggle()

  const nonRefundableDetail = 'Please note that ‘Non-Refundable’ packages are guaranteed at the time of booking and not eligible for a refund or date change. Accordingly, please select your package carefully and take note of any cancellation policy applicable to your purchase.'

  const onClickIcon: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault()
    togglePolicy()
  }

  return (
    <>
      <Clickable onClick={onClickIcon}>
        <BodyText variant="medium" as="span" weight="bold">Non-refundable</BodyText>
        {' '}<MiddledTooltipIcon size="XS" />
      </Clickable>
      <Modal
        title="Non-refundable"
        isOpen={isPolicyOpen}
        onClose={togglePolicy}
      >
        <BodyText variant="medium" as="p">{nonRefundableDetail}</BodyText>
        <HelpPane />
      </Modal>
    </>
  )
}

export default OfferPropertyNonRefundablePolicy
